import { useMutation } from "react-query";
import { updateOfficeVendorService } from "../../../../actions/CarrierAgreementMgmt/OfficeVendorService";

const useEditOfficeVendorService = () => {
  return useMutation(updateOfficeVendorService);
};
export default useEditOfficeVendorService;
